// extracted by mini-css-extract-plugin
export default {"video_link":"N6EuFkJr5dgLGqLoSJJw-"};